import { useCancellationModal } from "./CancellationModal";
import { LandingPage } from "./LandingPage";

export const MarketingHub = {
  LandingPage,
  useCancellationModal,
};
